module.exports = __webpack_public_path__ + "4f1079de4ceedd40f8845c6d52db1644.jpeg";